import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { PolygonSuccessDialog } from '../../components/dialogs/polygon-success-dialog/polygon-success-dialog';
import { MatDialog } from '@angular/material/dialog';
import { NavigateAwayGuardService } from './navigate-away-guard.service';
import { switchMap } from 'rxjs/operators';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree;
}

@Injectable()
export class NavigateAwayGuard {
  submitted: boolean = false;

  constructor(
    private dialog: MatDialog,
    private guardService: NavigateAwayGuardService,
  ) {}

  canDeactivate() {
    return this.guardService.canNavigate$.pipe(
      switchMap((canNavigate) => {
        if (canNavigate || this.submitted) {
          this.submitted = false;
          return of(true);
        } else {
          return this.confirmDialog();
        }
      }),
    );
  }

  async confirmDialog(): Promise<any> {
    let result: boolean;
    const dialogRef = this.dialog.open(PolygonSuccessDialog, {
      data: {
        msg: `Are you sure you want to exit this page? \n Your changes won’t be saved.`,
        step: 'discardCheckout',
      },
    });
    await dialogRef.componentInstance?.onDeliveryMethod.subscribe((value) => {
      result = value == 'close';
    });
    return dialogRef
      .afterClosed()
      .toPromise()
      .then(() => {
        return result;
      });
  }

  onSubmit(status: boolean): void {
    this.submitted = status;
  }
}
